/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Pin = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 12 17" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M11.157 9.21h-.003l.001-.005zm-.002-.005l-.033-.1c-.115.185-.239.21-.374.379l-4.041 7.11s-.273.404-.703.404c-.428 0-.702-.377-.702-.377l-4.046-7.07c-.132-.166-.253-.263-.366-.443l-.036.096c-.543-1.431-.861-2.045-.861-3.16 0-3.274 2.692-6.045 6.01-6.045 3.322 0 6.014 2.731 6.014 6.006 0 1.114-.319 1.768-.862 3.2zM.856 9.21H.852l.002-.006.002.006zm5.148-5.632c-1.269 0-2.302 1.019-2.302 2.27 0 1.252 1.033 2.27 2.302 2.27 1.27 0 2.304-1.018 2.304-2.27 0-1.251-1.033-2.27-2.304-2.27 0 0 1.268 0 0 0z" />
      </g>
    </svg>
  </span>
);

Pin.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Pin.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Pin;
